<template>
  <tr class="theater">
    <td>{{theater.theater_area}}</td>
    <td>
      <a v-if="theater.theater_website != ''" :href="theater.theater_website" :title="theater.theater_name" target="_blank">{{theater.theater_name}}</a>
      <span v-else>{{theater.theater_name}}</span>
    </td>
    <td><a :href="theaterTel" :title="theater.theater_phone">{{theater.theater_phone}}</a></td>
    <td>{{theater.theater_release_date}}</td>
  </tr>
</template>

<script>
export default {
  name: 'theater-item',
  props: {
    theater: Object
  },
  data () {
    return {
      commentsData: null
    }
  },

  computed: {
    theaterTel () {
      return 'tel:' + this.theater.theater_phone
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheatersItem.vue